import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import auth from '../../libCustom/auth';

const ActionsBar = (props) => {
  const { onEdit, onDelete, onPrint, onCancel, title, href } = props;
  const edit = <Tooltip id="edit_tooltip">Imprimir recibo</Tooltip>;
  const remove = <Tooltip id="cancel_tooltip">Cancelar recibo</Tooltip>;
  const noAuth = (
    <Tooltip id="noAuth_tooltip">Solo el Administrador puede cancelar</Tooltip>
  );
  return (
    <div className={css(styles.bar)}>
      <div>
        {/* <label
          className="checkbox-inline"
          style={{ marginTop: '6px', padding: 0 }}
        >
          <Checkbox
            style={{ color: '#000' }}
            number={index + 1}
            label="Seleccionar"
          />
        </label> */}
        {title ? <h3 className={css(styles.title)}>{title}</h3> : null}
      </div>
      <div>
        {/* PRINT BUTTON */}
        {onPrint ? (
          <OverlayTrigger placement="top" overlay={edit}>
            <a
              className={css(styles.button, styles.print)}
              onClick={onPrint}
              href={href}
              target="_blank"
              title={'Imprimir'}
            >
              <i className="fa fa-print" />
            </a>
          </OverlayTrigger>
        ) : null}

        {onCancel &&
          (auth.can('admin') || auth.can('matriz') || auth.can('support') ? (
            <OverlayTrigger placement="top" overlay={remove}>
              <a
                className={css(styles.button, styles.cancel)}
                onClick={onCancel}
                target="_blank"
              >
                <i className="fa fa-trash" />
              </a>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger placement="top" overlay={noAuth}>
              <a className={css(styles.button, styles.disabled)}>
                <i className="fa fa-trash" />
              </a>
            </OverlayTrigger>
          ))}

        {/* EDIT BUTTON */}
        {onEdit ? (
          <a className={css(styles.button, styles.edit)} onClick={onEdit}>
            <i className="fa fa-pencil-square-o" />
          </a>
        ) : null}

        {/* DELETE BUTTON */}
        {onDelete ? (
          <a className={css(styles.button, styles.delete)} onClick={onDelete}>
            <i className="fa fa-trash-o" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default ActionsBar;

const styles = StyleSheet.create({
  bar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'rgba(230,242,255,0.6)',
    minHeight: 44,
    borderRadius: 2,
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    color: '#0057a9',
    margin: '10px 15px',
  },
  button: {
    display: 'inline-block',
    fontFamily: 'Roboto',
    margin: '10px 15px 10px 0px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textTransform: 'uppercase',
    color: '#0057a9',
    transitionDuration: '0.25s',
    ':hover': {
      transform: 'scale(1.5)',
    },
  },
  delete: {
    color: '#f52b2b',
  },
  edit: {
    color: '#fc182d',
  },
  cancel: {
    color: '#fc182d',
  },
  disabled: {
    color: '#bfbfbf',
  },
});



// WEBPACK FOOTER //
// ./src/components/ActionsBar/ActionsBar.js